import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreatorV2/helpers";
import history from "../../history";
import { postGateForm } from "../../redux/actions/gateActions";

const DeclarationForm = ({ appData, postGateFormFunc }) => {
  let initialData = {};

  if (appData && appData.gateOnboarding && appData.gateOnboarding.declaration) {
    initialData = {
      ...initialData,
      ...appData.gateOnboarding.declaration,
    };
  }

  const getVal = getField(initialData);
  const validateTrue = (value) => !!value;

  const initialState = {
    Declaration1: {
      title:
        "I agree that in the event of a successful application that HRGO on behalf Gate Group in conjunction with the Civil Aviation Authority may carry out a Criminal Record Check.",
      value: getVal("Declaration1"),
      type: "singlecheckbox",
      mandatory: true,
      validate: validateTrue,
    },
    Declaration2: {
      title:
        "I authorise HRGO on behalf of Gate Group to contact former employers, educational establishments, government agencies and other referees listed in this application for verification of information in accordance with the Directive for Aviation Security.",
      value: getVal("Declaration2"),
      type: "singlecheckbox",
      mandatory: true,
      validate: validateTrue,
    },
    Declaration3: {
      title:
        "I understand that references received by HRGO on behalf of Gate Group are confidential and will not be disclosed to me or any other parties other than the relevant Airport Authority or Civil Aviation Authority security purposes.",
      value: getVal("Declaration3"),
      type: "singlecheckbox",
      mandatory: true,
      validate: validateTrue,
    },
    Declaration4: {
      title:
        "I understand should it be found that the successful candidate has failed to disclose any information as requested on this application form, or has provided false information, this will lead to a withdrawal of any job offer. If already in the business it will be highly likely that this will lead to Summary Dismissal.",
      value: getVal("Declaration4"),
      type: "singlecheckbox",
      mandatory: true,
      validate: validateTrue,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postGateFormFunc("declaration", {
      ...fieldValuesPayload,
    });

    history.push("/profile/edit/gate-group-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Declaration"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/gate-group-onboarding")}
      onboardingBranch={"#ADD_BRANCH#"} // <-- TODO
    />
  );
};

DeclarationForm.propTypes = {
  appData: any,
  postGateFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  postGateFormFunc: postGateForm,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(DeclarationForm);
